import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const api = buildService('/claims/{id}/claimer_messages', {
  only: ['all']
});
const useFetchAll = _ref => {
  let {
    claimId,
    setLoading,
    aif_claim_type
  } = _ref;
  const [claimerMessages, setClaimerMessages, fetchClaimerMessages] = serviceMethods.useFetch({
    callback: useCallback(async () => {
      if (claimId) {
        return await api.all(claimId, {
          aif_claim_type
        });
      }
    }, [aif_claim_type, claimId]),
    setLoading
  });
  return [claimerMessages, setClaimerMessages, fetchClaimerMessages];
};
const claimerMessagesService = {
  useFetchAll
};
export default claimerMessagesService;